import { render, staticRenderFns } from "./hunanNadi.vue?vue&type=template&id=581442c0&scoped=true&"
import script from "./hunanNadi.vue?vue&type=script&lang=js&"
export * from "./hunanNadi.vue?vue&type=script&lang=js&"
import style0 from "./hunanNadi.vue?vue&type=style&index=0&id=581442c0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581442c0",
  null
  
)

export default component.exports